import { Debouncer, animationFrame, PolymerElement } from 'polymer';

/**
 * used to contain a set of non-visual elements (eg. hi-http and hi-binding)
 * @todo share code with ai-state
 *
 * @customElement
 * @polymer
 * @appliesMixin HIP.BehaviorElement
 */
class GroupElement extends HIP.BehaviorElement(PolymerElement) {
  static get is() {
    return 'hi-group';
  }

  static get autoBinding() {
    return {
      signal: 'disabled-changed',
      field: 'disabled'
    };
  }

  static get api() {
    return ['deactivate', 'activate'];
  }

  connectedCallback() {
    super.connectedCallback();
    this.setAttribute('hidden', 'hidden');
  }

  activate() {
    this.disabled = false;
  }

  deactivate() {
    this.disabled = true;
  }

  refreshBindings() {
    return this.__setBindingsState(false);
  }

  _disabledChanged(_disabled) {
    super._disabledChanged(_disabled);
    this.__reflectDisabledState(_disabled);
  }

  __reflectDisabledState(_disabled) {
    this.__disabledDebouncer = Debouncer.debounce(this.__disabledDebouncer, animationFrame, () => {
      this.__setBindingsState(_disabled);
    });
  }

  __setBindingsState(disabled) {
    Array.from(this.children)
      .filter((el) => el.nodeName === 'HI-BINDING')
      .forEach((el) => {
        el.disabled = disabled;
        // if (el.disabled === disabled) {
        //   el.relink();
        // }
        // else {
        //   el.disabled = disabled;
        // }
      });
  }
}

HIP.factory.element(GroupElement);
